import Logs from "../../components/logs/Logs";

const TaskLogs = () => {
  return <Logs />;
};

export default TaskLogs;
